import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../core/http/api.service';
import {environment} from '../../../environments/environment';
import {LocalStorageService} from '../../core/services/local-storage.service';
import {SharedServiceService} from '../../core/services/shared-service.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})

export class LoginComponent implements OnInit {

  username = '';
  password = '';
  isInvalid = false;
  errMessage = '';

  constructor(private api: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private shared: SharedServiceService,
              private auth: LocalStorageService) {
  }

  ngOnInit(): void {
  }

  adminLogin(): void {
    this.api.loginAdmin({username: this.username, password: this.password}).subscribe((data) => {
      this.isInvalid = false;
      window.localStorage.setItem(environment.authKey, data.token);
      this.auth.setValue(environment.authKey, data.token);
      this.shared.userLoggedIn.emit();
      this.router.navigateByUrl('/home', {replaceUrl: true});
    }, (err) => {
      this.isInvalid = true;
      if (err.status === 400) {
        this.errMessage = 'Invalid Password';
      } else if (err.status === 401) {
        this.errMessage = 'User does not exist';
      } else {
        this.errMessage = 'User not Found';
      }
    });
  }
}
